import React, { useEffect, useRef, useState } from 'react'
import "./Crie.css"
import Loader from '../../../Loader/Loader';
import moment from 'moment';
import CrieDirectPathPdf from './CrieDirectPathPdf';
import CrieIndirectPathPdf from './CrieIndirectPathPdf';
const CriePdf = () => {

    const feedBoxOneData = localStorage.getItem("cdp")
    const feedBoxOne = (JSON.parse(feedBoxOneData)) || []
    let dataForInformation = feedBoxOne?.dataForInformation
    let crieData = feedBoxOne?.crieData



    return (
        <>
            <div className='DecisionMaker-table-main crit_out'>
                <div className='crie-cont-main-crie'>
                    <div className='crie-cont'>
                        <p className='company-head-crie'>Company and Relationship Intelligence Explorer (CRIE)</p>

                    </div>
                    <div>
                        <p className='urilize-subhead-crie'>Utilize the filters below to quickly find direct paths from JobsOhio to <span style={{ textTransform: "capitalize" }}>{dataForInformation?.name}</span>.</p>
                        <p className='directpath-crie'>{crieData?.length} Direct Paths </p>
                    </div>
                </div>

                <CrieDirectPathPdf style={{ pageBreakInside: "avoid" }}
                />
                <div className='crie-cont-main-crie' style={{ pageBreakInside: "avoid", breakBefore: 'page' }}>
                    <div>
                        <p className='urilize-subhead-crie'>Utilize the filters below to quickly find indirect paths from JobsOhio to <span style={{ textTransform: "capitalize" }}>{dataForInformation?.name}</span>.</p>
                        {/* <p className='directpath-crie'> {indirectCount ? ` ${indirectCount} Indirect paths` : null} found as of {inDirectSummary?.generated_date ? moment(inDirectSummary?.generated_date).format('M.DD.YY') : moment(inDirectSummary?.generated_date).format('M.DD.YY')}</p> */}
                    </div>
                </div>

                <CrieIndirectPathPdf />
            </div>
        </>
    )
}
export default CriePdf